import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.eggShell,
  h1Color: colors.smoke,
  h2Color: colors.smoke,
  paraColor: colors.smoke,
  anchorColor: colors.brickOrange
};
export default richText;